import React from 'react'
import { Flex } from '@chakra-ui/react'
import { EventsSearchBar } from '../../components/SearchBar/EventsSearchBar'

function Events(): JSX.Element {
  return (
    <Flex flexDirection='column' alignItems={'center'} padding={'40px 120px 0px 40px'} height={'100%'}>
      <EventsSearchBar />
    </Flex>
  )
}

export { Events }
